import { Scenario } from "../lib/models/rental/rental.model";
import { QuoteMetadata, QuoteSfIntegration } from "../lib/types/QuoteMetadata";
import { QuoteType } from "../lib/types/QuoteType";
import { CalculationType, QuotingType } from "./quote-reducer";

export type QuoteState = {
  quote: QuotingType;
  quoteCalculation: CalculationType;
  isSaving: boolean;
  isCalculating: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  hasCalculated: boolean;
  hasQuoteBeenSubmitted: boolean;
  isNewQuote: boolean;
  quoteType: QuoteType | null;
  rentalQuoteScenarios: Scenario[];
  requiresRecalculation: boolean;
  calculationWarnings?: {
    calculation?: string;
    feeLLPAsFactored?: string;
    rateLLPAsFactored?: string;
    overridePricing?: string;
    warnings?: string;
  };
  hasCalculationErrors?: boolean;
  hasFormErrors?: boolean;
  quoteFormErrors?: string;
  isDirty?: boolean;
  metadata?: QuoteMetadata;
  sfIntegration?: QuoteSfIntegration;
  requiresQuoteResubmission?: boolean;
  username?: string;
};

export const initialQuoteState: QuoteState = {
  quote: null,
  quoteCalculation: null,
  isCalculating: false,
  isSaving: false,
  isLoading: false,
  isSubmitting: false,
  hasCalculated: false,
  hasQuoteBeenSubmitted: false,
  isNewQuote: true,
  quoteType: null,
  rentalQuoteScenarios: [],
  requiresRecalculation: false,
  calculationWarnings: undefined,
  hasCalculationErrors: false,
  hasFormErrors: false,
  quoteFormErrors: "",
  isDirty: false,
  metadata: undefined,
  sfIntegration: undefined,
  requiresQuoteResubmission: false,
  username: "",
};
